import kitchenInstance from '../../instance'

const updateWaiterNotificationWaiterComing = (id, data) => {
	return kitchenInstance.put(`/waiterNotifications/${id}/waiterComing`, data)
}

export default updateWaiterNotificationWaiterComing
